import { defineStore } from 'pinia'
import repository from '@/repositories/repositoryFactory';
import { encryptPassword } from '@/util/PasswordFunctions';
import { resetStore } from '@/util/StoreFunctions';

// ログイン情報保持store
export const useUserStore = defineStore({
    id: "user",
    state: () => {
        return {
            userId: '', // ログインID
            userName: '', // ユーザ名
            token: '', // トークン
            isExpired: false, // 認証切れか？
            isActivated: false, // アクティベーション済みか？
            isNeedAddNotify: false, // 通知先の登録が必要か？
            isLogout: false, // ログアウトされたか？
        }
    },
    getters: {
        isLogined(): boolean{
            return this.token != '';
        },
    },
    actions: {
        // ログイン
        async login(userId: string, password: string) {
            // チャレンジキー発行
            const publicKey = await repository.auth.getPublicKey(userId);

            // パスワードの暗号化
            const passwordRsa = await encryptPassword(password, publicKey);

            // ログイン実行
            const resAuth = await repository.auth.login(userId, passwordRsa);

            // ログイン情報を保持
            this.userId = userId;
            this.userName = resAuth.companyName;
            this.token = resAuth.token;
            this.isExpired = false;
            this.isActivated = resAuth.isActivated;
            this.isNeedAddNotify = resAuth.isNeedAddNotify;
            this.isLogout = false;
        },
        // ログアウト
        logout() {
            // ストアのリセット
            resetStore();

            this.userId = '';
            this.userName = '';
            this.token = '';
            this.isExpired = false;
            this.isActivated = false;
            this.isNeedAddNotify = false;
            this.isLogout = true;
        },
        // 認証切れ
        expired() {
            this.logout();
            this.isExpired = true;
        }
    },
    // データの永続化(セッション単位)
    persist: {
        enabled: true,
        strategies: [
            {
                storage: sessionStorage
            }
        ]
    }
})

// 端末ログイン情報保持store
export const useDeviceStore = defineStore({
    id: "device",
    state: () => {
        return {
            isLoginedOnDevice: false, // 端末(ブラウザ)でログインしたことがあるか？
        }
    },
    // データの永続化(ローカルストレージ)
    persist: {
        enabled: true,
        strategies: [
            {
                storage: localStorage
            }
        ]
    }
})